module.exports = __webpack_public_path__ + "resources/img/img-tmax-hyper-sql-for-postgre-sql-01-m.c2135aebf4cc95e94b4c9097da65da35.png";